export default "__VITE_ASSET__0wRXWbzL__"